import { useState, useEffect } from 'react'
import { telegramBotIntegrationApi } from '@/api/index.js'

/**
 * Хук для работы с интеграцией Telegram бота
 * @param {Object} settings - настройки приложения
 * @param {string|number} userId - ID пользователя
 * @returns {boolean} - показывать ли кнопку активации Telegram бота
 */
export const useTelegramBotIntegration = (settings, userId) => {
  const [showTelegramBotIntegrationButton, setShowTelegramBotIntegrationButton] = useState(false)

  useEffect(() => {
    if (settings?.telegramBotIntegrationEnabled === '1' && userId) {
      telegramBotIntegrationApi
        .checkIsActive({ user_id: userId })
        .then((res) =>
          setShowTelegramBotIntegrationButton(res?.data?.data?.is_active === false)
        )
        .catch(() => setShowTelegramBotIntegrationButton(false))
    } else {
      setShowTelegramBotIntegrationButton(false)
    }
  }, [settings?.telegramBotIntegrationEnabled, userId])

  return showTelegramBotIntegrationButton
}
